// extracted by mini-css-extract-plugin
export default {"Error":"RegisterUser_Error__ZsEpn","SubmitButton":"RegisterUser_SubmitButton__-oy0M","InputWidth":"RegisterUser_InputWidth__Qa+3O"};